import { useTranslation } from 'react-i18next';
import { ACCOUNT_TYPE_OPTIONS } from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { RadiosField, RadiosFieldProps } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

type AccountTypeFieldProps = Omit<RadiosFieldProps, 'name'>;
export const AccountTypeField = (props: AccountTypeFieldProps) => {
  const { t } = useTranslation();
  const accountTypeOptions = useTranslateOptions(ACCOUNT_TYPE_OPTIONS);

  return (
    <RadiosField<InfluencerFormKeys>
      help={t('Tooltip.DisplayCampaignHelp')}
      options={accountTypeOptions}
      title={t('Label.Account Type')}
      name={InfluencerSharedKeys.brandAccount}
      {...props}
    />
  );
};
